let loaded = false
export default async ({ version = 'v2' } = {}) => {
  if (loaded) return window.Stripe
  const script = document.createElement('script')

  script.async = true
  script.src = `https://js.stripe.com/${version}/`

  document.body.appendChild(script)

  return new Promise((resolve, reject) => {
    loaded = true
    script.onload = () => resolve(window.Stripe)
    script.onerror = (err) => reject(err)
  })
}
